package com.pincer.core

val DEFAULT_LOCALE = "en-US"
val DEFAULT_ZONE = "US/Eastern"